<div class="card card-custom">
  <div class="card-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed" [formGroup]="categoryForm">
    <div class="navi-hover scroll card-body" [perfectScrollbar]="{ wheelPropagation: false }">
      <div class="form-group">
        <div class="row">
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <kt-alert
              *ngIf="duplicateError"
              type="warn"
              [duration]="30000"
              [showCloseButton]="true"
              (closeAl)="onAlertClose()"
            >
              <span
                >A team with this name already exists in your company. Please choose a different
                name.</span
              >
            </kt-alert>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field appearance="fill" class="mat-form-field-fluid">
              <mat-label translate="CATEGORY.FORM.NAME">Name</mat-label>
              <input matInput formControlName="name" required />
              <mat-error translate="CATEGORY.FORM.NAME_REQUIRED">Name is required</mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>Email</mat-label>
              <input type="email" matInput formControlName="email" />
              <mat-error *ngIf="isControlHasError('email', 'email')">
                {{ 'AUTH.EMAIL' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col-lg-12 kt-margin-bottom-20-mobile">
            <mat-form-field class="mat-form-field-fluid" appearance="fill">
              <mat-label>Fax</mat-label>
              <input matInput formControlName="fax_number" maxlength="14" ktAppPhoneMask />
              <mat-error *ngIf="isControlHasError('fax_number', 'pattern')">
                {{ 'AUTH.VALIDATION.PATTERN' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div class="row">
          <div class="col kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [appearance]="'fill'"
              [label]="'Role'"
              [loadItemsFunction]="searchRolesFn"
              [optionFormatter]="filterRoleFn"
              [valueFormatter]="filterRoleFn"
              [required]="false"
              [readOnly]="false"
              [control]="roleCtrl"
              [change]="selectRole.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Select Roles'"
              [chipList]="true"
              [objects]="roleCtrl.value"
              [formatNewObjectFn]="formatNewRoleFn"
              #roleAutocomplete
            ></kt-general-autocomplete>
          </div>
        </div>
        <div class="row">
          <div class="col kt-margin-bottom-20-mobile">
            <kt-general-autocomplete
              [appearance]="'fill'"
              [label]="'Inbox'"
              [loadItemsFunction]="searchInboxFn"
              [optionFormatter]="filterRoleFn"
              [valueFormatter]="filterRoleFn"
              [required]="false"
              [readOnly]="false"
              [control]="inboxCtrl"
              [change]="selectInbox.bind(this)"
              [dataPath]="'data'"
              [placeholder]="'Select Inbox'"
              [formatNewObjectFn]="formatNewInboxFn"
              #searchInboxAutocomplete
            ></kt-general-autocomplete>
          </div>
        </div>
        <div class="row" *ngIf="category && category.id">
          <mat-form-field
            appearance="fill"
            class="mat-form-field-fluid col-lg-12 kt-margin-bottom-20-mobile example-chip-list"
          >
            <mat-label>Team Managers</mat-label>
            <mat-chip-list
              formControlName="managerControl"
              #chipList
              aria-label="Status selection"
              class="managers-chips"
            >
              <mat-chip
                *ngFor="let manager of selectedManagers; let i = index"
                [removable]="true"
                (removed)="removeManager(manager)"
                style="margin-right: 15px"
                [ngStyle]="{ backgroundColor: '#dfdfdf', color: '#000000' }"
              >
                <input
                  type="checkbox"
                  (change)="markAsPrimaryManager(manager)"
                  style="width: 18px; height: 18px; margin-right: 5px"
                  [disabled]="selectedManagers.length < 2 || manager.is_manager"
                  [matTooltip]="
                    manager.is_manager ? 'Primary Manager' : 'Select as primary manager'
                  "
                  [checked]="manager.is_manager"
                />
                {{ manager | getUserFullName }}
                <mat-icon matChipRemove>cancel</mat-icon>
              </mat-chip>
              <input
                #managerInput
                [matChipInputFor]="chipList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                [matChipInputAddOnBlur]="true"
                [matAutocomplete]="auto"
                [disabled]="areRolesEmpty"
              />
            </mat-chip-list>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectManager($event)">
              <mat-option
                *ngFor="let manager of managers"
                [value]="manager"
                [disabled]="isASelectedManager(manager)"
              >
                {{ manager | getUserFullName }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>
        <div class="row">
          <div class="col-lg-6 kt-margin-bottom-20-mobile" style="padding-left: 30px">
            <mat-label class="row">Intervention Permission</mat-label>
            <mat-slide-toggle
              class="row mt-2 mr-2"
              formControlName="hasInterventionPermission"
            ></mat-slide-toggle>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile" style="padding-left: 30px">
            <mat-label class="row">Default Team</mat-label>
            <mat-slide-toggle
              [disabled]="disableDefaultTeam"
              class="row mt-2 mr-2"
              formControlName="isDefaultInterventionTeam"
            ></mat-slide-toggle>
          </div>
          <div class="col-lg-6 kt-margin-bottom-20-mobile" style="padding-left: 30px">
            <mat-label class="row">Is Active</mat-label>
            <mat-slide-toggle class="row mt-2 mr-2" formControlName="isActive"></mat-slide-toggle>
          </div>
        </div>
      </div>
    </div>
    <div class="card-footer">
      <div class="d-flex justify-content-between">
        <div class="mr-2"></div>
        <div>
          <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
            <span translate="GLOBAL.CANCEL">Cancel</span></button
          >&nbsp;
          <button
            type="button"
            mat-raised-button
            color="primary"
            (click)="onSubmit()"
            matTooltip="Create"
          >
            <span translate="GLOBAL.SAVE">Save</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
